import axios from 'axios';

// const API_HEADER = 'https://test.xhmember.sdeast8.com/prod-api/';
const API_HEADER = 'https://yzdxh.sdeast8.com/prod-api/';
// const API_HEADER = 'http://localhost:8080/';

const post = (url, data) => {
    return axios.post(API_HEADER + url, data);
};

const get = (url, params) => {
    return axios.get(API_HEADER + url, { params });
};

export { post, get };
